import { FC, useEffect } from "react";
import {
  updatePaymentFlow,
  updatePaymentMethod,
} from "redux/form/form.reducer";
import { selectSource } from "redux/form/form.selector";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { FormSourceType } from "utils/interfaces";

const PaymentManager: FC = () => {
  const source = useAppSelector(selectSource);
  const dispatch = useAppDispatch();
  const isKckForm = source === FormSourceType.KCK_FORM;

  useEffect(() => {
    // For the KCK form we only have direct_debit option
    // and we need to select it as the default Payment Method
    if (isKckForm) {
      dispatch(updatePaymentFlow("direct_debit"));
      dispatch(updatePaymentMethod("bank_withdrawal"));
    }
  }, [isKckForm]);

  return null;
};

export default PaymentManager;
